/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-len */

import * as React from 'react';
import EventCardLine from './lineCard';
import moment from 'moment';
import _ from 'lodash';
import { CTooltip, CTooltipLabel, CTooltipText } from './../../components/tooltip/';
import { parseResponse } from '/client/src/pages/Events/detail/listView/helper';
import { Link } from 'react-router-dom';
import { convertToLocalTime } from '/client/src/utils/jstz';

type PropsType = {
  id?: string,
  image_url?: string,
  image_crop_info?: {
    x1: number,
    x2: number,
    y1: number,
    y2: number
  },
  name?: string,
  location?: string,
  begin_time_utc?: string,
  end_time_utc?: string,
  time_zone_id?: string,
  collaboratorsList?: [],
  transactions?: {
    [string]: string | number | [] | null
  },
  is_set_tickets_total_capacity: boolean,
  tickets_total_capacity: number,
  setEventList?: () => void,
  eventList?: []
};

  class EventCardLineSimple extends React.PureComponent<PropsType> {
  render(): React.Element<'div'> {
    const {
      id,
      image_url,
      image_crop_info,
      name,
      location,
      begin_time_utc,
      end_time_utc,
      collaboratorsList,
      transactions,
      is_set_tickets_total_capacity,
      tickets_total_capacity,
      time_zone_id,
      status
    } = this.props;

    const startTime = begin_time_utc ? convertToLocalTime(begin_time_utc, time_zone_id, 'MMM Do, h:mm A') : '';
    const endTime = end_time_utc ? convertToLocalTime(end_time_utc, time_zone_id, 'MMM Do, h:mm A z') : '';

    const {
      sold_quantity
    } = parseResponse(transactions, is_set_tickets_total_capacity, tickets_total_capacity);

    const x1 = _.get(image_crop_info, 'x1', 0);
    const x2 = _.get(image_crop_info, 'x2', 0);
    const y1 = _.get(image_crop_info, 'y1', 0);
    const y2 = _.get(image_crop_info, 'y2', 0);

    const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=480`;
    const isGrayFilterClass = (new Date(end_time_utc).getTime() - new Date().getTime()) < 0 || status === 'Close' || status === 'Archive';

    return (
      <EventCardLine id={id} startDate={begin_time_utc}  {...this.props}>
        <div className="EventCardLine-col">
          <div className="EventCardLine-dateImg">
            <div className="EventCardLine-dateImg-img-placeholder">
              <div
                className={`EventCardLine-dateImg-img ${isGrayFilterClass ? 'filter--gray' : ''}`}
                style={{
                  backgroundImage: `url("${image_url}?${imageUrlParams}")`
                }}
              />
            </div>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-description">
            <h4>{name}</h4>

            <p>{startTime} - {endTime}</p>
            <p>{location}</p>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-tickets">
            <h4>Tickets sold</h4>

            <p>{sold_quantity ? sold_quantity : '0'} / {transactions.ticket_quantity_expected}</p>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-collaborators">
            <h4>Collaborators</h4>

            <div className="event-users">
              {!_.size(collaboratorsList) ?
                <span>loading...</span> :
                null
              }
              {_.map(collaboratorsList, (ci: {}, ck: number): React.Element<'div'> => {
                if (ck <= 2) {
                  return (
                    <div
                      key={`collaboratorsList-${ck}`}
                      className="event-users-item"
                      title={`${ci.first_name[0]} ${ci.last_name[0]}`}
                    >
                      <Link
                        to={{ pathname: `/events/${this.props.id}/manage/collaborators` }}
                      >
                        <CTooltip>
                          <CTooltipLabel>
                            <i>{ci.first_name[0]}{ci.last_name[0]}</i>
                          </CTooltipLabel>
                          <CTooltipText>{ci.first_name} {ci.last_name}</CTooltipText>
                        </CTooltip>
                      </Link>
                    </div>
                  );
                }
              })}
              {_.size(collaboratorsList) > 3 ?
                <div
                  className="event-users-item"
                  title={`+ ${_.size(collaboratorsList) - 3}`}
                >
                  <Link
                    to={{ pathname: `/events/${this.props.id}/manage/collaborators` }}
                  >
                    <i>{`+ ${_.size(collaboratorsList) - 3}`}</i>
                  </Link>
                </div> : null
              }
            </div>
          </div>
        </div>
      </EventCardLine>
    );
  }
}

EventCardLineSimple.defaultProps = {
  begin_time_utc: null,
  end_time_utc: null,
  transactions: {
    sold_quantity: '-',
    ticket_quantity_expected: '-',
    amount: '-',
    merchant_revenue: '-'
  }
};

export default EventCardLineSimple;
